import { Title } from '@solidjs/meta'
import { type Component, For } from 'solid-js'
import Card from '~/components/Card'
import Icon from '~/components/Icon'
import { type Path, useNavigate } from '~/router'

/** /admin/builder no tenía pantalla propia: entrar ahí dejaba el área vacía. */
const SECTIONS: { key: string; title: string; description: string; icon: string; href: Path; color: string }[] = [
  {
    key: 'paginas',
    title: 'Páginas',
    description: 'Crea y publica páginas dinámicas del sitio.',
    icon: 'material-symbols-light:web',
    href: '/admin/builder/paginas',
    color: 'text-purple-500'
  },
  {
    key: 'modelos',
    title: 'Modelos de Datos',
    description: 'Define la estructura de la información que guardas.',
    icon: 'material-symbols-light:database-outline',
    href: '/admin/builder/modelos',
    color: 'text-blue-500'
  },
  {
    key: 'componentes',
    title: 'Componentes',
    description: 'Bloques reutilizables para armar tus páginas.',
    icon: 'material-symbols-light:widgets-outline',
    href: '/admin/builder/componentes',
    color: 'text-emerald-500'
  },
  {
    key: 'temas',
    title: 'Temas',
    description: 'Colores y tipografías con los que se ven las páginas.',
    icon: 'material-symbols-light:palette-outline',
    href: '/admin/builder/temas',
    color: 'text-orange-500'
  }
]

const BuilderHomePage: Component = () => {
  const navigate = useNavigate()

  return (
    <>
      <Title>Builder | Florez Jaramillo</Title>

      <div class="space-y-6">
        <div>
          <h1 class="text-2xl font-bold text-foreground">Builder</h1>
          <p class="text-sm text-foreground-subtle">Todo lo que arma el sitio: páginas, datos, componentes y temas.</p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          <For each={SECTIONS}>
            {section => (
              <Card class="cursor-pointer transition-shadow hover:shadow-md" onClick={() => navigate(section.href)}>
                <Card.Body>
                  <Icon icon={section.icon} size={28} class={section.color} />
                  <h2 class="font-semibold text-foreground mt-3">{section.title}</h2>
                  <p class="text-sm text-foreground-subtle mt-1">{section.description}</p>
                </Card.Body>
              </Card>
            )}
          </For>
        </div>
      </div>
    </>
  )
}

export default BuilderHomePage
